
import { Component, Prop, State, Vue } from 'nuxt-property-decorator';
import { IGamesState } from '~/store/games/types';
import NftCard from './NftCard.vue';
import NftCardSkeletonLoader from './NftCardSkeletonLoader.vue';

@Component({
  components: {
    NftCard,
    NftCardSkeletonLoader,
  },
})
export default class ProjectItemsForSale extends Vue {
  @Prop(String) readonly slug!: string;

  @State((state: IGamesState) => state.itemsForSaleByGala, {
    namespace: 'games',
  })
  readonly itemsForSale!: IGamesState['itemsForSaleByGala'];

  @State((state: IGamesState) => state.itemsForSaleState, {
    namespace: 'games',
  })
  readonly itemsForSaleState!: IGamesState['itemsForSaleState'];
}
